<template>
  <!-- 广汽关键词管理 -->
  <div class="page_padding">
    <div class="page_content" v-if="authority">
      <div class="head topAn">
        <el-button type="primary" size="mini" plain @click="addUser">
          <i class="el-icon-plus"></i>新增
        </el-button>
        <!-- 筛选 -->
        <div class="screening_box">
          <el-input
            v-model="searchFrom.name"
            placeholder="请输入名称"
            clearable
            @change="search"
          ></el-input>
          <el-select
            v-model="searchFrom.type"
            filterable
            placeholder="请选择类型"
          >
            <el-option
              :label="type.name"
              :value="type.id"
              v-for="(type, i) in screen_typeArr"
              :key="i"
              >{{ type.name }}</el-option
            >
          </el-select>
        </div>
      </div>
      <!-- 列表 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
          stripe
        >
          <el-table-column
            width="150"
            prop="name"
            :show-overflow-tooltip="true"
            label="名称"
          >
          </el-table-column>
          <el-table-column width="150" label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 0">一般检索</span>
              <span v-if="scope.row.type == 1">大屏集团检索</span>
              <span v-if="scope.row.type == 2">大屏车型检索</span>
            </template>
          </el-table-column>
          <el-table-column label="关键词">
            <template slot-scope="scope">
              <el-popover placement="top-start" width="700" trigger="click">
                <div class="word_box">
                  <h3>{{ scope.row.name }}关键词:</h3>
                  <div>{{ scope.row.keywords }}</div>
                </div>
                <div class="key_words" slot="reference">
                  {{ scope.row.keywords }}
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column align="right" label="操作" width="230">
            <template slot-scope="scope">
              <template>
                <el-button
                  size="mini"
                  style="margin-left: 0px;"
                  @click.stop="getTopic(scope.row)"
                  >关联专题</el-button
                >
                <el-button
                  size="mini"
                  style="margin-left: 0px;"
                  @click.stop="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-popconfirm
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  :hideIcon="true"
                  title="确定删除吗？"
                  @confirm="handleDelete(scope.$index, scope.row.id)"
                >
                  <el-button slot="reference" size="mini" type="danger"
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <Pagination
        :total="total"
        :list="tableData"
        :page="page"
        :pageSize="pageSize"
        @change="changePage"
      />

      <!-- 新增/编辑 -->
      <el-dialog
        :title="is_add ? '新增' : '编辑'"
        :top="dialog_top"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
        @close="cancel"
      >
        <el-form :model="wordForm" :rules="rules" ref="wordForm">
          <!-- 名称 -->
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="wordForm.name"
              placeholder="请输入名称"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 类型 -->
          <el-form-item label="类型" prop="type">
            <el-select
              v-model="wordForm.type"
              filterable
              placeholder="请选择类型"
            >
              <el-option
                :label="type.name"
                :value="type.id"
                v-for="(type, i) in typeArr"
                :key="i"
                >{{ type.name }}</el-option
              >
            </el-select>
          </el-form-item>
          <!-- 关键词 -->
          <el-form-item label="关键词" prop="keywords">
            <el-input
              type="textarea"
              :rows="6"
              v-model="wordForm.keywords"
              placeholder="请输入关键词"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancel">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="submitForm"
            >{{ is_add ? "确 定" : "保 存" }}</el-button
          >
        </div>
      </el-dialog>

      <!-- 查看关联专题 -->
      <el-dialog
        :title="name + ' 关联专题'"
        top="15vh"
        width="70%"
        :visible.sync="rule_show"
      >
        <el-dialog
          width="80%"
          top="5vh"
          :title="!is_add ? '编辑专题' : '添加专题'"
          :close-on-click-modal="false"
          @close="innerVisible = false"
          :visible.sync="innerVisible"
          append-to-body
        >
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <!-- 专题 -->
            <el-form-item label="选择专题" prop="ruleId"></el-form-item>
            <div>
              <el-radio-group size="small" v-model="ruleForm.ruleId">
                <el-radio
                  style="margin-bottom: 10px;"
                  :label="key"
                  v-for="(val, key) in classObj"
                  :key="key"
                  border
                >
                  {{ val }}</el-radio
                >
              </el-radio-group>
            </div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="innerVisible = false"
              >取 消</el-button
            >
            <el-button
              size="mini"
              type="primary"
              :loading="btnLoading"
              :disabled="btnLoading"
              @click="saveTopic"
              >{{ !is_add ? "保 存" : "确 定" }}</el-button
            >
          </div>
        </el-dialog>
        <!-- 添加/编辑专题模块 -->
        <div class="add_wxUser">
          <el-button
            type="primary"
            size="mini"
            plain
            class="add_btn"
            @click="addTopic"
          >
            添加专题
          </el-button>
        </div>
        <!-- 列表 -->
        <div class="invitation_list">
          <el-table
            v-load="rule_loading"
            :data="rule_list"
            style="width: 100%"
            :height="320"
            stripe
          >
            <el-table-column prop="name" label="名称"> </el-table-column>
            <el-table-column prop="ruleName" label="专题名称">
            </el-table-column>
            <el-table-column align="right" label="操作" width="150">
              <template slot-scope="scope">
                <template>
                  <el-button
                    size="mini"
                    @click.stop="clickEditTopic(scope.$index, scope.row)"
                  >
                    编辑</el-button
                  >
                  <el-popconfirm
                    confirmButtonText="确定"
                    cancelButtonText="取消"
                    :hideIcon="true"
                    title="确定删除吗？"
                    @confirm="delTopic(scope.$index, scope.row.id)"
                  >
                    <el-button slot="reference" size="mini" type="danger"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
import mixins from "../../../mixins";

export default {
  mixins: [mixins],
  data() {
    return {
      btnLoading: false,
      searchFrom: {
        name: "",
        type: ""
      },
      typeArr: [
        { name: "一般检索", id: 0 },
        { name: "大屏集团检索", id: 1 },
        { name: "大屏车型检索", id: 2 }
      ],
      screen_typeArr: [],
      dialogFormVisible: false,
      rule_show: false,
      is_add: true,
      // 表单
      wordForm: {
        name: "",
        type: 0,
        keywords: ""
      },
      // 表单检验规则
      rules: {
        name: [{ required: true, message: "请输入用户id", trigger: "blur" }],
        type: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        keywords: [{ required: true, message: "请选择公司", trigger: "blur" }],
        ruleId: [{ required: true, message: "请选择专题", trigger: "blur" }]
      },
      dialog_top: "5vh",
      row_index: 0,
      lableId: "",
      id: "",
      name: "",
      ruleForm: {
        ruleId: ""
      },
      rule_loading: false,
      rule_list: [],
      is_init: false,
      innerVisible: false,
      classObj: {}
    };
  },
  watch: {
    "searchFrom.type": {
      deep: true,
      handler() {
        this.page = 1;
        this.getList("search");
      }
    }
  },
  created() {
    this.getAllClass();
  },
  mounted() {
    this.screen_typeArr = JSON.parse(JSON.stringify(this.typeArr));
    this.screen_typeArr.unshift({ name: "全部", id: "" });
  },
  methods: {
    initList() {
      this.is_init = true;
      this.searchFrom = {
        name: "",
        type: ""
      };
      this.page = 1;
      this.getList();
    },
    // 获取所有专题
    getAllClass() {
      if (!this.authority) return;
      this.$http({
        url: this.$api.all_classList,
        data: {
          companyid: ""
        }
      }).then(res => {
        if (res.code == 0) {
          this.classObj = {};
          res.data.forEach(val => {
            this.classObj[val.ruleId] = val.ruleName;
          });
        }
      });
    },
    // 获取列表
    getList(type = "") {
      if (!this.authority) return;
      this.loading = true;
      this.tableScrollTop();
      this.$http({
        url: this.$api.word_list,
        data: {
          name: this.searchFrom.name,
          type: this.searchFrom.type,
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.loading = false;
        this.is_init = false;
        if (res.code == 0) {
          if (type == "search") {
            if (res.data.total == 0) this.$message("没有搜索到用户");
          }
          this.total = res.data.total;
          this.tableData = res.data.concent;
        }
      });
    },
    // 新增/编辑
    editWordReq(data) {
      this.btnLoading = true;
      this.$http({
        url: this.$api.edit_word,
        data
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          if (this.is_add) {
            this.initList();
            this.$hint("添加成功");
          } else {
            this.tableData[this.row_index].name = data.name;
            this.tableData[this.row_index].type = data.type;
            this.tableData[this.row_index].keywords = data.keywords;
            this.$hint("保存成功");
          }
        } else {
          this.$hint(res.code + "：" + res.message, "err");
        }
      });
    },
    // 删除
    handleDelete(index, id) {
      this.$http({
        url: this.$api.del_word,
        data: { id }
      }).then(res => {
        if (res.code == 0) {
          this.tableData.splice(index, 1);
          this.total--;
          this.$hint("删除成功");
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 搜索
    search() {
      this.page = 1;
      this.getList("search");
    },
    // 查看关联专题
    getTopic(row) {
      this.lableId = row.lableId;
      this.name = row.name;
      this.rule_show = true;
      this.getRuleList();
    },
    // 添加用户
    addUser() {
      this.dialogFormVisible = true;
      this.is_add = true;
      this.wordForm = {
        name: "",
        type: 0,
        keywords: ""
      };
    },
    // 点击编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.is_add = false;
      this.row_index = index;
      this.wordForm = {
        name: row.name,
        type: row.type,
        keywords: row.keywords,
        id: row.id
      };
    },
    // 点击新增、保存
    submitForm() {
      this.$refs.wordForm.validate(valid => {
        if (valid) {
          let item = JSON.parse(JSON.stringify(this.wordForm));
          this.editWordReq(item);
          this.cancel();
        } else {
          return false;
        }
      });
    },
    // 点击取消
    cancel() {
      this.dialogFormVisible = false;
      this.$refs.wordForm.resetFields();
    },
    // 获取关联专题列表
    getRuleList() {
      this.rule_loading = true;
      this.$http({
        url: this.$api.rule_list,
        data: {
          ruleId: "",
          lableId: this.lableId,
          pageIndex: 1,
          pageSize: 999
        }
      }).then(res => {
        this.rule_loading = false;
        if (res.code == 0) {
          this.rule_list = res.data.concent;
        }
      });
    },
    // 点击添加关联专题
    addTopic() {
      this.innerVisible = true;
      this.is_add = true;
      this.ruleForm = {
        ruleId: ""
      };
    },
    // 点击编辑关联专题
    clickEditTopic(index, row) {
      this.innerVisible = true;
      this.is_add = false;
      this.id = row.id;
      this.row_index = index;
      this.ruleForm.ruleId = row.ruleId;
    },
    // 添加/编辑关联专题
    addTopicReq() {
      this.btnLoading = true;
      let id = "";
      if (!this.is_add) id = this.id;
      this.$http({
        url: this.$api.edit_topic,
        data: {
          ruleId: this.ruleForm.ruleId,
          lableId: this.lableId,
          id
        }
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          this.innerVisible = false;
          let hint_text = "添加成功";
          if (!this.is_add) {
            hint_text = "保存成功";
            this.rule_list[this.row_index].ruleId = res.data.ruleId;
            this.rule_list[this.row_index].ruleName = res.data.ruleName;
          } else {
            this.getRuleList();
          }
          this.$hint(hint_text);
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 删除关联专题
    delTopic(index, id) {
      this.$http({
        url: this.$api.del_topic,
        data: { id }
      }).then(res => {
        if (res.code == 0) {
          this.rule_list.splice(index, 1);
          this.$hint("删除成功");
        } else {
          this.$hint(res.code + "：" + res.message, "err");
        }
      });
    },
    // 确定新增、编辑关联专题
    saveTopic() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.addTopicReq();
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style>
.input_box .el-input__inner {
  height: 35px;
}
.date_item {
  height: 35px;
  margin-left: 10px;
}
.date_item > input {
  height: 100%;
}
</style>
<style lang="less" scoped>
.add_wxUser {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;
  transform: translateY(-25px);
  .el-form-item {
    margin: 0;
  }
  .input_box {
    width: 200px;
    height: 35px;
  }
  .add_btn {
    height: 35px;
    color: #fff;
    letter-spacing: 2px;
    margin-left: 10px;
    padding: 0 15px;
  }
}
.invitation_list {
  width: 100%;
}

.time_item {
  display: flex;
  align-items: center;
  > span {
    width: 140px;
    margin-right: 10px;
    white-space: nowrap;
  }
}

.word_box {
  > h3 {
    color: #525f7f;
    margin-bottom: 10px;
  }
}
.key_words {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/gacKeyWord.vue